export const iconFontAwesomeDevicesHardwareTabletScreenButton = (
	<i className="fa-solid fa-tablet-screen-button"></i>
);
